
import { Context } from '@nuxt/types'
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import BlogAcfBlocks from '~/components/blog/BlogAcfBlocks.vue'
import LiveopsWhitepaperHomepage from '~/components/liveops-whitepaper/LiveopsWhitepaperHomepage.vue'
import { PageData } from '~/domain/interfaces/PageDataTypes'

export default defineComponent({
  name: 'liveops-whitepaper',
  components: { LiveopsWhitepaperHomepage, BlogAcfBlocks },
  extends: MachinationsLightPage,
  layout: 'landingpage',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `Liveops Whitepaper`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'The Ultimate Game Design Platform',
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context: Context) {
    const { $config, store } = context

    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'liveops-whitepaper',
    })

    return {
      pageData,
    }
  },
})
